import { AbstractControl } from '@angular/forms';
export class CustomDatesValidator {
    
    static DateError(group: AbstractControl) {
        let month = new Date().getMonth() +1;
        let year = new Date().getFullYear();
        let expiryMonthField = group.get('cardExpiryMonth');
        let expiryYearField = group.get('cardExpiryYear');

        let expiryMonth = expiryMonthField.value;
        let expiryYear = expiryYearField.value;
        if((expiryMonth['name'] < month) && (expiryYear['name'] <= year) || expiryMonth == "" || expiryYear == "") {
            expiryMonthField.setErrors({expired:true}); 
            expiryYearField.setErrors({expired:true}); 
        } else {
            expiryMonthField.setErrors(null);
            expiryYearField.setErrors(null);
        }
    }
}